/*
 * Copyright © 2020-2024 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @LastEditTime: 2025-12-04 16:01:52
 */
/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2024-09-12 18:20:18
 */
import React, { useState, useMemo } from 'react'
import { Button, DatePicker, Form, Input, Select } from 'antd'
import DepartmentMemberPicker from '../../components/DepartmentMemberPickerV2'
import sensors from 'sa-sdk-javascript'
import { useAppSelector } from '../../../app/hooks'
const { Item: FormItem } = Form

const { RangePicker } = DatePicker

export default ({
  filter,
  setFilter,
  onSubmit,
  onReset,
  onReportSaClickEvent
}) => {
  const [showMemberPickerModal, setShowMemberPickerModal] = useState(false)
  const pickerUserCount = useAppSelector(
    (state) => state.organization.pickerOrgUserCount
  )

  const handleMemberChangeV2 = (params) => {
    const { selectedDepartmentUsers, selectedDepartments } = params
    setShowMemberPickerModal(false)
    setFilter({
      ...filter,
      departments: selectedDepartments,
      departmentUsers: selectedDepartmentUsers
    })
  }

  const pickedMembersNum = useMemo(() => {
    const userNumInDepartments = (filter.departments || [])
      .map((department) => department.num)
      .reduce((acc, cur) => acc + cur, 0)
    const total = (filter.departmentUsers || []).length + userNumInDepartments
    const hasSelection =
      (filter.departmentUsers || []).length > 0 ||
      (filter.departments || []).length > 0
    if (
      (!hasSelection && total === 0) ||
      total === pickerUserCount ||
      (filter.departments || []).some((department) => department.id === '0')
    ) {
      return pickerUserCount
    } else {
      return total
    }
  }, [filter, pickerUserCount])

  const memberPickerValue = useMemo(() => {
    if (pickedMembersNum === pickerUserCount) {
      return '全部成员'
    }
    return `已选${pickedMembersNum}人`
  }, [pickedMembersNum, pickerUserCount])

  return (
    <div className="Filter filter-container">
      <div
        style={{
          display: 'flex'
        }}
      >
        <Form layout="inline">
          <FormItem label="筛选跟进人">
            <Select
              style={{ width: '236px' }}
              value={memberPickerValue}
              open={false}
              onDropdownVisibleChange={() => {
                setShowMemberPickerModal(true)
              }}
            ></Select>
          </FormItem>
          <FormItem label="筛选内容">
            <Input
              style={{ width: '236px' }}
              placeholder="搜索名称/地点/地区"
              value={filter.keyword}
              onChange={(e) => {
                setFilter({ ...filter, keyword: e.target.value })
              }}
            />
          </FormItem>
        </Form>

        <Form layout="inline">
          <FormItem label="" colon={false} style={{ marginLeft: '12px' }}>
            <Button
              type="primary"
              style={{ marginRight: '10px' }}
              onClick={onSubmit}
            >
              开始筛选
            </Button>
            <Button onClick={onReset}>重置</Button>
          </FormItem>
        </Form>
      </div>
      <DepartmentMemberPicker
        open={showMemberPickerModal}
        filterObj={filter}
        onOk={handleMemberChangeV2}
        onCancel={() => setShowMemberPickerModal(false)}
      />
    </div>
  )
}
